import {
    Box,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

const FittingsOrders = ({orders}) => {
    if (!orders || orders?.length == 0) {
        return <></>;
    }
    return (
        <Grid item xs={12}>
            <Typography sx={{textAlign: "center", background: "#d8d8d8"}} variant="h6" my={1}>
                ORDERS
            </Typography>
            {orders?.map((order, index) => (
                <Box key={index} my={2}>
                    <Grid container>
                        {/* Order Header */}
                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <strong>Order Source:</strong> {order.orderSource}
                            </Typography>
                            <Typography variant="body2">
                                <strong>Order Number:</strong> {order.orderNumber}
                            </Typography>
                        </Grid>
                        {/* Oracle Info */}
                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <strong>Oracle Order Number:</strong> {order.ebsOrderNumber}
                            </Typography>
                            <Typography variant="body2">
                                <strong>Oracle Status:</strong> {order?.ebsOrderStatus ?? "UnKnow"}
                            </Typography>
                            <Typography variant="body2">
                                <strong>Oracle Date:</strong>{" "}
                                {order?.ebsOrderDate && new Date(order?.ebsOrderDate).toLocaleString()}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Oracle Order Lines */}
                    <Box mt={2}>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ITEM TYPE</TableCell>
                                        <TableCell>SKU</TableCell>
                                        <TableCell>DESCRIPTION</TableCell>
                                        <TableCell align="center">QUANTITY</TableCell>
                                        <TableCell align="center">STATUS</TableCell>
                                        <TableCell>STATUS UPDATE ON</TableCell>
                                        <TableCell>SCHEDULED ARRIVAL</TableCell>
                                        <TableCell>TRACKING #</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {order?.orderLines.map((line, idx) => {
                                        const itemType =
                                            line.clubConfig?.clubType?.name ??
                                            line.clubConfig?.clubTypeV2?.name ??
                                            "Product";

                                        const sku = line.product?.sku ?? "—";
                                        const description =
                                            line.product?.description ?? line.clubConfig?.displayHeadModelName ?? "—";

                                        return (
                                            <TableRow key={idx}>
                                                <TableCell>{itemType}</TableCell>
                                                <TableCell>{sku}</TableCell>
                                                <TableCell>{description}</TableCell>
                                                <TableCell align="center">{line.quantity}</TableCell>
                                                <TableCell align="center">{line.latestStatus ?? "—"}</TableCell>
                                                <TableCell>
                                                    {line.latestStatusDate
                                                        ? new Date(line.latestStatusDate).toLocaleDateString()
                                                        : "—"}
                                                </TableCell>
                                                <TableCell>
                                                    {line.scheduledArrivalDate
                                                        ? new Date(line.scheduledArrivalDate).toLocaleDateString()
                                                        : "—"}
                                                </TableCell>
                                                <TableCell>{line.trackingNumber ?? "—"}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            ))}
        </Grid>
    );
};

export default FittingsOrders;
